import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import axios from "../../../axios";

export const getTeamMembers = () => ({ type: "GET_TEAM_MEMBERS" })
export const getTeamMembersRequest = () => ({ type: "GET_TEAM_MEMBERS_REQUEST" })
export const getTeamMembersSuccess = payload => ({ type: "GET_TEAM_MEMBERS_SUCCESS", payload })
export const getTeamMembersFailed = error => ({ type: "GET_TEAM_MEMBERS_FAILED", error })

export function* getTeamMembersSaga() {
    yield put(getTeamMembersRequest())
    try {
        let { data: payload } = yield call(axios,"/team_members")
        yield put(getTeamMembersSuccess(payload))
    } catch(err){
        yield put(getTeamMembersFailed(err))
    }
}

export default function* teamMembersSagaWatcher() {
    yield takeEvery("GET_TEAM_MEMBERS", getTeamMembersSaga)
}